import { Redirect, useParams } from "react-router-dom";
import { PageHeaderWithBack } from "../../../Components/Molecules";
import { useAuth } from "../../../Contexts/AuthContext";
import { ContaInternacionalTransferirContent } from "./components/ContaInternacionalTransferirContent";
import {
  CONTA_INTERNACIONAL_HOME_PATH,
  contaInternacionalCurrencyPath,
  getCurrency,
  JURISDICTION,
} from "./constants";

export const ContaInternacionalTransferir = () => {
  const { hasPermission } = useAuth();
  const { currencyId } = useParams();
  const currency = getCurrency(currencyId);

  if (!hasPermission("internationaltransfer")) {
    return <Redirect to={CONTA_INTERNACIONAL_HOME_PATH} />;
  }

  if (!currency) {
    return <Redirect to={CONTA_INTERNACIONAL_HOME_PATH} />;
  }

  return (
    <div className="w-full">
      <PageHeaderWithBack
        title="Transferir"
        subTitle={`Meios disponíveis para sua jurisdição (${JURISDICTION.countryLabel}).`}
        backTo={contaInternacionalCurrencyPath(currency.id)}
      />

      <div className="app-card p-4 sm:p-5">
        <ContaInternacionalTransferirContent isActive currencyId={currency.id} />
      </div>
    </div>
  );
};
